import request from '@/utils/request';
import Base from '@/api/base.ts';

export default class LayoutMgr extends Base {
  // 获取登录用户权限
  public static getUserMenuRole(username: string) {
    return request.get(`/api/menu/${username}`);
  }
  // 修改用户密码
  public static updatePassword(newPassword: string, oldPassword: string) {
    return request.put(`/api/user/password/update`,
    {
      oldPassword,
      newPassword
    });
  }
}
